import { rankingItems } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热度排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时更新的热门漫画排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="group flex items-center gap-3 md:gap-5 p-4 md:p-5 rounded-2xl bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div
                className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                <span className="text-sm md:text-base font-heading">{item.rank}</span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</span>
                  {item.trend === 'up' && (
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                    </div>
                  )}
                </div>
                <p className="text-xs text-foreground-600">{item.desc}</p>
              </div>

              <div className="text-right flex-shrink-0">
                <span className="text-sm md:text-base font-heading text-primary-500 whitespace-nowrap">
                  {item.heat}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}